import React, { useContext, useEffect, useRef, useState } from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import { store } from "components/Common/Socket/store"
import { put, del } from "helpers/api_helper"
import { invalidateEventCache } from "./eventCachePolicy"
import { runEventCommand } from "./runEventCommand"
import { DeleteEventRule, DisableEventCopy, EnableEventCopy } from "./eventStatusCopy"

export default function EventOperationDialog({ event, action, onClose, onSuccess }) {
  const context = useContext(store)
  const { socket, socketClientId } = context?.state?.socket || {}
  const [result, setResult] = useState({ status: "idle" })
  const active = useRef(), alive = useRef(true)
  useEffect(() => () => { alive.current = false; active.current?.cancel() }, [])
  const pending = result.status === "pending", unknown = result.status === "unknown"
  const verb = action === "deleted" ? "Delete" : action === "disabled" ? "Disable" : "Enable"
  const submit = async () => {
    if (active.current || pending || unknown) return
    setResult({ status: "pending" })
    active.current = runEventCommand({ eventId: event._id, socket,
      submit: correlationId => {
        const config = { timeout: 10000, headers: { "X-Correlation-Id": correlationId } }
        return action === "deleted"
          ? del("/admin/events/" + event._id, { socketClientId }, config)
          : put("/admin/events/" + event._id + "/status/" + action, { socketClientId }, config)
      },
    })
    const outcome = await active.current.promise
    if (!alive.current) return
    setResult(outcome)
    if (outcome.status === "saved") {
      invalidateEventCache({ eventId: event._id })
      onSuccess(outcome)
    } else if (outcome.status === "error") active.current = undefined
  }
  const close = () => {
    if (unknown) invalidateEventCache({ eventId: event._id })
    onClose(unknown)
  }
  return <Modal isOpen toggle={pending ? undefined : close} backdrop={pending ? "static" : true} keyboard={!pending}>
    <ModalHeader toggle={pending ? undefined : close}>{verb} event?</ModalHeader>
    <ModalBody><p><strong>{event.name}</strong> · #{event.eventId}</p>
      {action === "deleted" ? <><p>This marks the event as deleted and removes it from event listings.</p><DeleteEventRule /></>
        : action === "disabled" ? <DisableEventCopy name={event.name} /> : <EnableEventCopy name={event.name} />}
      {pending && <p role="status">Waiting for confirmation…</p>}
      {unknown && <p role="status">The request was sent, but its result is not confirmed. Close and refresh the list to inspect the current status before sending another request.</p>}
      {result.status === "error" && <p role="alert" className="text-danger">{result.message}</p>}
    </ModalBody>
    <ModalFooter><button className="btn btn-light" disabled={pending} onClick={close}>{unknown ? "Close and refresh" : "Cancel"}</button>
      {!unknown && <button className={"btn btn-" + (action === "deleted" ? "danger" : "primary")} disabled={pending} onClick={submit}>{pending ? "Processing…" : verb + " event"}</button>}
    </ModalFooter>
  </Modal>
}
